/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delete-icon': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<path pid="0" d="M10.393 3.068h3.243a.511.511 0 010 1.023h-1.193v8.894c0 .826-.65 1.504-1.461 1.504H4.018c-.812 0-1.461-.678-1.461-1.504V4.091H1.363a.511.511 0 010-1.023h3.585a2.727 2.727 0 015.444 0zm-1.027 0a1.705 1.705 0 00-3.392 0h3.392zm2.054 1.023H3.58v8.894c0 .27.2.48.438.48h6.964c.237 0 .438-.21.438-.48V4.091zM5.284 6.247a.511.511 0 011.023 0v4.964a.512.512 0 01-1.023 0V6.247zm3.409 0a.511.511 0 011.023 0v4.964a.512.512 0 01-1.023 0V6.247z" _fill="#707070"/>'
  }
})
